import { render, staticRenderFns } from "./TemplateBlockSettings.vue?vue&type=template&id=42b01fa8&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateBlockSettings.vue?vue&type=script&lang=js&"
export * from "./TemplateBlockSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b01fa8')) {
      api.createRecord('42b01fa8', component.options)
    } else {
      api.reload('42b01fa8', component.options)
    }
    module.hot.accept("./TemplateBlockSettings.vue?vue&type=template&id=42b01fa8&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('42b01fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/TemplateBlockSettings.vue"
export default component.exports